import axios from '@/lib/axios'
import { UseQueryOptions, useQuery } from '@tanstack/vue-query'

interface Props {
	id: string | number
	hash: string
	queryOptions?: Omit<
		UseQueryOptions<any, any, any, any>,
		'queryKey' | 'queryFn'
	>
}

const getVerifyEmail = async ({ id, hash }: Props) => {
	const { data, status } = await axios.get(`verify-email/${id}/${hash}`)

	return { data, status }
}

const useVerifyEmail = ({ id, hash, queryOptions }: Props) => {
	const { data, isLoading, isFetching } = useQuery({
		queryKey: ['verify-email', id, hash],
		queryFn: () => getVerifyEmail({ id, hash }),
		...queryOptions,
	})

	return {
		data,
		isLoading,
		isFetching,
	}
}

export default useVerifyEmail
